import { COMPONENT_NAME_PREFIX } from '../constants';

const elementName: keyof HTMLElementTagNameMap = `${COMPONENT_NAME_PREFIX}skeleton`;

export const SKELETON_CONSTANTS = {
  elementName
};
